import { checkIfShouldCloseListAndCreateAParagraph } from '@xingternal/content-editor-plugin-helpers';

import { ListItem } from './ListItem';
import { withLists } from './utils';
// eslint-disable-next-line max-len

const ListItemPlugin = ({ className, LIST_ITEM_TAG, ...attributes } = {}) => ({
  with: withLists,
  onKeyDown: checkIfShouldCloseListAndCreateAParagraph(),
  renderElement: ListItem({
    className,
    LIST_ITEM_TAG,
    ...attributes,
  }),
});

export { ListItemPlugin };
